import React, { Component } from 'react';
import { connect } from 'react-redux';
import { History } from 'history';

import AwbsContainer from '../forwarderImport/awbs/ AwbsContainer';
import PaymentReportWrapper from '../paymentReport/PaymentReportWrapper';
import UserManagementContainer from '../administration/UserManagement/UserManagementContainer';
import ManageRfsContainer from '../rfs/manageRfs/ManageRfsContainer';

import User, { UserRoleType } from '../../models/User';

import roleConfig from '../../configs/roles';
import ShipmentInventoryContainer from '../shipmentInventory/ShipmentInventoryContainer';
import ScreeningDetailsContainer from '../screeningDetails/ScreeningDetailsContainer';

interface ContentWrapperState { };

interface ContentWrapperProps {
  user: User;
  history: History;
};

class ContentWrapper extends Component<ContentWrapperProps, ContentWrapperState> {

  setContent = (): any => {
    switch (this.props.user.roleId) {

      case roleConfig.roleId.forwarderUser: return <AwbsContainer history={ this.props.history } userRole={ UserRoleType.FORWARDER }/>;
      case roleConfig.roleId.forwarderAdmin: return <UserManagementContainer />;
      case roleConfig.roleId.ghaWarehouseScreener:
      case roleConfig.roleId.ghaSupervisorWh:
      case roleConfig.roleId.ghaWarehouse: 
        this.props.history.push('/whs-dashboard');
        break;
      case roleConfig.roleId.ghaOffice:
      case roleConfig.roleId.superUser:
      case roleConfig.roleId.laxOfficeAgent:
      case roleConfig.roleId.ghaManager:
      case roleConfig.roleId.ghaManagerWh:
      case roleConfig.roleId.ghaSupervisor:
      case roleConfig.roleId.laxOfficeAgent:
      case roleConfig.roleId.ghaDashboard: 
        this.props.history.push('/dashboard');
        break;
      case roleConfig.roleId.ghaAccounting:
      case roleConfig.roleId.ghaAccReco:
      case roleConfig.roleId.ghaAdmin: return <PaymentReportWrapper />;
      case roleConfig.roleId.ghaAirlineRepresentative: return <ShipmentInventoryContainer />;
      case roleConfig.roleId.ghaScreener: return <ScreeningDetailsContainer history={ this.props.history } match={{ params: {code: '', number: '', version: '', orderNumber: ''}}}/>;
      case roleConfig.roleId.ghaOfflineRFSRep: return <ManageRfsContainer history={ this.props.history } userRole={ UserRoleType.GHA} />;
      case roleConfig.roleId.ghaOfflineRFSRep: this.props.history.push('/manage-rfs');
      
      default: return null;
    }
  }

  render () {
    return (
      <div>
        { this.setContent() }
      </div>
    );
  };
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user
  };
};

export default connect(mapStateToProps, null)(ContentWrapper);